module.exports = __webpack_public_path__ + "static/media/drag.e5165eb0.svg";